import {h, Fragment} from "preact"
import QuickBuySizeList from "./QuickBuySizeList"

export default function QuickBuy({
    productName,
    hasQuickBuy,
    quickBuyRef,
    showQuickBuyOptions,
    onOpen,
    productOptions,
    isSizeAvailable,
    isAddingToCart,
    selectedSize,
    onQuickBuy
}) {
    if (!hasQuickBuy) return null

    return (
        <div class="ns-quick-buy-container" ref={quickBuyRef}>
            {!showQuickBuyOptions ? (
                <button
                    class="ns-quick-buy-btn"
                    onClick={(event) => {
                        event.preventDefault()
                        event.stopPropagation()
                        onOpen()
                    }}
                    onKeyDown={(event) => {
                        if (event.key === "Enter" || event.key === " ") {
                            event.preventDefault()
                            event.stopPropagation()
                            onOpen()
                        }
                    }}
                    aria-label={`Quick buy ${productName}`}
                    tabIndex="0"
                >
                    Quick Buy
                </button>
            ) : (
                <QuickBuySizeList
                    productName={productName}
                    productOptions={productOptions}
                    isSizeAvailable={isSizeAvailable}
                    isAddingToCart={isAddingToCart}
                    selectedSize={selectedSize}
                    onQuickBuy={onQuickBuy}
                />
            )}
        </div>
    )
}

